var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGongxian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.0769,
    y: 3.69238,
    width: 5.22172,
    height: 1.74057,
    transform: "rotate(-45 11.0769 3.69238)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 14.7693,
    width: 5.22172,
    height: 1.74057,
    transform: "rotate(-45 0 14.7693)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.69232,
    y: 11.0769,
    width: 3.48114,
    height: 1.74057,
    transform: "rotate(-45 3.69232 11.0769)",
    fill: "#00C2FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.61539,
    y: 6.15387,
    width: 3.48114,
    height: 1.74057,
    transform: "rotate(-45 8.61539 6.15387)",
    fill: "#00C2FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.76923,
    y: 8,
    width: 1.74057,
    height: 1.74057,
    transform: "rotate(-45 6.76923 8)",
    fill: "#00C2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGongxian);
export default __webpack_public_path__ + "static/media/gongxian.8be5627927ccc388ec24d0650e37e75f.svg";
export { ForwardRef as ReactComponent };